export {
  Slot,
  Slottable,
  SlotProvider,
  //
  Root,
  Provider,
  //
  createSlot,
  createSlottable,
  //
  mergeProps,
} from './slot';
export type { SlotProps, MergePropsFunction } from './slot';
